import { bus_data } from './busData'
import _ from 'lodash'
import { roundNumber } from 'helpers/helper'

const formatValue = (value: any) => value.toLowerCase().replace(' ', '_')

const filtered_data_by_bus_type = bus_data.filter(
  (item: any) => item.fuel_type.toLocaleLowerCase() !== 'diesel',
)

const bus_type_uniques = _.uniq(_.map(filtered_data_by_bus_type, 'bus_type'))

export const bus_type_options = bus_type_uniques.map((item) => ({
  value: formatValue(item),
  label: item,
}))

export const bus_data_by_bus_type = (bus_type: string) =>
  filtered_data_by_bus_type.filter((item) => formatValue(item.bus_type) === formatValue(bus_type))

export const maxCapacity = filtered_data_by_bus_type.map((item) => ({
  type: item.bus_type.toLowerCase(),
  value: item.passenger_capacity,
}))

export const timeConvert = (n: any) => {
  const parseNumber = _.toNumber(n)
  const hours = parseNumber / 60
  const rhours = Math.floor(hours)
  const minutes = (hours - rhours) * 60
  const rminutes = Math.round(minutes)
  return n ? `${rhours}  hours  ${rminutes} minutes` : 0
}

export const mileToKm = (value: number) => {
  const res = value * 1.60934
  return roundNumber(res)
}
export const kmToMile = (value: number) => {
  const res = value / 1.60934
  return roundNumber(res)
}

export const weekDaysOrder = (arr: any) => {
  const list = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun']
  return arr ? list.filter((each) => arr.includes(each)) : []
}
